<template>
  <HeaderView />
<!--  <div class="min-h-screen bg-gray-50">-->
  <div class="min-h-screen bg-gray-700">
    <div class="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <!-- Privacy Policy Section -->
      <div class="bg-white p-6 sm:p-8 shadow-sm rounded-lg mb-12">
        <h1 class="text-2xl font-bold text-gray-900 mb-8 border-b pb-4">Privacy Policy</h1>

        <div class="space-y-8 text-gray-700">
          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">Data Collection</h2>
            <p class="leading-relaxed">
              We collect personal information and usage data to provide, maintain, and improve our services.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">Data Usage</h2>
            <p class="leading-relaxed">
              Your data is used for customer service, platform improvements, and analytics.
              We do not sell your personal information.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">Data Protection</h2>
            <p class="leading-relaxed">
              We implement industry-standard security measures including encryption and access controls
              to safeguard user information.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">User Rights</h2>
            <p class="leading-relaxed">
              You have the right to request access to, correction of, or deletion of your personal data.
              Contact us to exercise these rights.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">Third Party Sharing</h2>
            <p class="leading-relaxed">
              We may share data with trusted third-party services for analytics and operational purposes,
              always under strict data processing agreements.
            </p>
          </section>

          <div class="mt-10 pt-6 border-t border-gray-200">
            <h3 class="text-lg font-semibold text-gray-900 mb-4">Contact Information</h3>
            <p class="text-gray-700">
              For privacy concerns or data requests, contact us at:
              <a href="mailto:cs@usmanheart.org" class="text-blue-600 hover:underline">cs@usmanheart.org</a>
            </p>
          </div>
        </div>
      </div>

      <!-- Terms of Use Section -->
      <div class="bg-white p-6 sm:p-8 shadow-sm rounded-lg">
        <h1 class="text-2xl font-bold text-gray-900 mb-8 border-b pb-4">Terms of Use</h1>

        <div class="space-y-8 text-gray-700">
          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">1. Eligibility</h2>
            <p class="leading-relaxed">
              Some of the services that includes social communication are available only to individuals aged 18 years or older.
              By using our platform, you represent and warrant you meet this requirement.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">2. License Grant</h2>
            <p class="leading-relaxed">
              We grant you a limited, non-exclusive, non-transferable license to access and use our services
              for lawful purposes. Reverse engineering or unauthorized access is strictly prohibited.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">3. User Obligations</h2>
            <p class="leading-relaxed">
              Users must provide accurate information and comply with all applicable laws. Prohibited
              activities include uploading unauthorized content or engaging in disruptive server activities.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">4. Service Availability</h2>
            <p class="leading-relaxed">
              While we strive for 24/7 availability, we cannot guarantee uninterrupted service and reserve
              the right to modify or discontinue services temporarily or permanently.
            </p>
          </section>

          <section>
            <h2 class="text-lg font-semibold text-gray-900 mb-3">5. Liability</h2>
            <p class="leading-relaxed">
              To the maximum extent permitted by law, we exclude all liability for damages arising from
              platform use. This includes indirect, incidental, or consequential damages.
            </p>
          </section>

          <div class="mt-10 pt-6 border-t border-gray-200">
            <p class="text-sm text-gray-500">
              Effective: January 1, 2024 | Version: 1.0<br>
              Governing Law: Estonian Law<br>
              Contact: <a href="mailto:cs@usmanheart.org" class="text-blue-600 hover:underline">cs@usmanheart.org</a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <FooterView />
  </div>
</template>

<script>
import HeaderView from "@/components/HeaderView.vue";
import FooterView from "@/components/FooterView.vue";

export default {
  name: 'PrivacyPolicy',
  components: {FooterView, HeaderView }
}
</script>
